import { GetMemberGroupResponse } from '@/modules/manage-member/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMemberGroupList } from '../../services'
import { GetMemberGroupRequest } from '@/modules/manage-member/type'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetMemberGroup(
	payload: GetMemberGroupRequest,
	props?: UseBaseQueryOptions<GetMemberGroupResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetMemberGroup, payload],
		queryFn: () => getMemberGroupList(payload),
		refetchOnWindowFocus: false,
		...props,
	})
}
